<main>
  <p-toast position="top-center" />
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'Withholding_Taxes' | translateWF: 'Withholding Taxes' }}</h1>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'Reload' | translateWF: 'Reload'" (click)="loadTypes()" variant="outlined" icon="pi pi-refresh" />
          <span class="separator"></span>
          @if (!isReadOnly) {
            <p-button [label]="'Add_Type' | translateWF: 'Add Type'" (click)="addType()" icon="pi pi-plus" />
          }
        </div>
      </div>
    </div>

    <!-- Filters -->
    <p-panel header="Filter">
      <ng-template pTemplate="icons">
        <label class="row-sm-start-center">
          <p-checkbox [formControl]="includeInactive" [binary]="true" (onChange)="loadTypes()" />
          {{ 'Include_Inactive' | translateWF: 'Include inactive' }}
        </label>
      </ng-template>
      <p-card data-variant="fields">
        <div class="form-box">
          <label>{{ 'Country' | translateWF: 'Country' }}</label>
          <p-select
            appendTo="body"
            [formControl]="countryFilter"
            [options]="countryOptions"
            optionLabel="label"
            optionValue="value"
            [showClear]="true"
            [placeholder]="'All_Countries' | translateWF: 'All countries'"
            styleClass="w-full"
            (onChange)="loadTypes()"
          />
        </div>
      </p-card>
    </p-panel>

    <!-- Type create/edit form -->
    @if (showTypeForm()) {
      <div class="p-4 border border-gray-300 rounded">
        <div class="row-between-center mb-4">
          <h2>
            @if (editingType()) {
              {{ 'Edit_Type' | translateWF: 'Edit Withholding Type' }}
            } @else {
              {{ 'New_Type' | translateWF: 'New Withholding Type' }}
            }
          </h2>
          <div class="buttons">
            <p-button class="mr-2" [label]="'Save' | translateWF: 'Save'" (click)="saveType()" [disabled]="typeForm.invalid" />
            <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancelTypeForm()" />
          </div>
        </div>

        <div class="grid-12">
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Country' | translateWF: 'Country' }} *</label>
              <p-select
                [formControl]="typeForm.controls.countryCode"
                [options]="countryOptions"
                optionLabel="label"
                optionValue="value"
                [placeholder]="'Select' | translateWF: 'Select'"
                styleClass="w-full"
              />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Code' | translateWF: 'Code' }} *</label>
              <input pInputText [formControl]="typeForm.controls.code" class="w-full" placeholder="HN-ISR-SVC" />
              <small class="text-surface-500">{{ 'Immutable_Once_Created' | translateWF: 'Immutable once created.' }}</small>
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Name_En' | translateWF: 'Name (EN)' }} *</label>
              <input pInputText [formControl]="typeForm.controls.nameEn" class="w-full" placeholder="ISR services" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Name_Es' | translateWF: 'Name (ES)' }}</label>
              <input pInputText [formControl]="typeForm.controls.nameEs" class="w-full" placeholder="ISR servicios" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Description_En' | translateWF: 'Description (EN)' }}</label>
              <input pInputText [formControl]="typeForm.controls.descriptionEn" class="w-full" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Description_Es' | translateWF: 'Description (ES)' }}</label>
              <input pInputText [formControl]="typeForm.controls.descriptionEs" class="w-full" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Tax_Kind' | translateWF: 'Tax kind' }}</label>
              <p-select [formControl]="typeForm.controls.taxKind" [options]="taxKindOptions" optionLabel="label" optionValue="value" styleClass="w-full" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Timing' | translateWF: 'Timing' }}</label>
              <p-select [formControl]="typeForm.controls.timing" [options]="timingOptions" optionLabel="label" optionValue="value" styleClass="w-full" />
            </div>
          </div>
          <div class="span-6-3">
            <div class="form-box">
              <label>{{ 'Base' | translateWF: 'Base' }}</label>
              <p-select [formControl]="typeForm.controls.baseType" [options]="baseTypeOptions" optionLabel="label" optionValue="value" styleClass="w-full" />
            </div>
          </div>
          <div class="span-6-3 flex items-end">
            <div class="form-box">
              <label class="row-sm-start-center">
                <p-checkbox [formControl]="typeForm.controls.isActive" [binary]="true" />
                {{ 'Active' | translateWF: 'Active' }}
              </label>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Types table -->
    <p-panel header="Results">
      <p-card data-variant="compact">
        <p-table *ngIf="types().length > 0" [value]="paginatedTypes()" selectionMode="single" [selection]="selectedType()" dataKey="id" (onRowSelect)="onTypeRowSelect($event)">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'Country' | translateWF: 'Country' }}</th>
              <th>{{ 'Code' | translateWF: 'Code' }}</th>
              <th>{{ 'Name' | translateWF: 'Name' }}</th>
              <th>{{ 'Tax_Kind' | translateWF: 'Kind' }}</th>
              <th>{{ 'Timing' | translateWF: 'Timing' }}</th>
              <th>{{ 'Base' | translateWF: 'Base' }}</th>
              <th>{{ 'Active' | translateWF: 'Active' }}</th>
              <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-type>
            <tr [pSelectableRow]="type" [class.bg-primary-50]="selectedType()?.id === type.id">
              <td>{{ type.countryCode }}</td>
              <td>
                <a class="cs-table-link" (click)="selectType(type)">{{ type.code }}</a>
              </td>
              <td>{{ type.name | localized }}</td>
              <td>
                <p-tag [value]="taxKindLabel(type.taxKind)" [severity]="type.taxKind === TaxKind.IncomeTax ? 'info' : 'warn'" />
              </td>
              <td>{{ timingLabel(type.timing) }}</td>
              <td>{{ baseTypeLabel(type.baseType) }}</td>
              <td>
                <p-tag [value]="type.isActive ? 'Yes' : 'No'" [severity]="type.isActive ? 'success' : 'danger'" />
              </td>
              <td>
                <p-button
                  icon="pi pi-list"
                  [rounded]="true"
                  [text]="true"
                  severity="secondary"
                  (click)="selectType(type); $event.stopPropagation()"
                  [pTooltip]="'View_Codes' | translateWF: 'View codes'"
                />
                @if (!isReadOnly) {
                  <p-button
                    icon="pi pi-pencil"
                    [rounded]="true"
                    [text]="true"
                    severity="info"
                    (click)="editType(type); $event.stopPropagation()"
                    [pTooltip]="'Edit' | translateWF: 'Edit'"
                  />
                }
              </td>
            </tr>
          </ng-template>
        </p-table>

        @if (types().length > 0) {
          <p-paginator
            [rows]="typesPageSize()"
            [totalRecords]="types().length"
            [first]="(typesCurrentPage() - 1) * typesPageSize()"
            (onPageChange)="onTypesPageChange($event)"
            [rowsPerPageOptions]="[10, 20, 50]"
          />
        }

        @if (types().length === 0 && !loading()) {
          <div class="text-center py-8 text-gray-500">
            <p>{{ 'No_Types_Found' | translateWF: 'No withholding types found. Add one or change the country filter.' }}</p>
          </div>
        }
      </p-card>
    </p-panel>

    <!-- Codes for the selected type -->
    @if (selectedType(); as type) {
      <div class="p-4 border border-gray rounded">
        <div class="row-between-center mb-4">
          <h2>
            {{ 'Codes_For' | translateWF: 'Codes for' }} <span class="font-mono">{{ type.code }}</span> — {{ type.name | localized }}
          </h2>
          @if (!isReadOnly) {
            <p-button [label]="'Add_Code' | translateWF: 'Add Code'" (click)="addCode()" icon="pi pi-plus" size="small" />
          }
        </div>

        <!-- Code create/edit form -->
        @if (showCodeForm()) {
          <div class="mb-4 p-4 border border-gray rounded-lg bg-white">
            <div class="row-between-center mb-4">
              <h3>
                @if (editingCode()) {
                  {{ 'Edit_Code' | translateWF: 'Edit Code' }}
                } @else {
                  {{ 'New_Code' | translateWF: 'New Code' }}
                }
              </h3>
              <div class="buttons">
                <p-button class="mr-2" [label]="'Save' | translateWF: 'Save'" (click)="saveCode()" [disabled]="codeForm.invalid" size="small" />
                <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancelCodeForm()" size="small" />
              </div>
            </div>

            <div class="grid-12">
              <div class="span-6-3">
                <div class="form-box">
                  <label>{{ 'Code' | translateWF: 'Code' }} *</label>
                  <input pInputText [formControl]="codeForm.controls.code" class="w-full" placeholder="HN-ISR-SVC-RES" />
                </div>
              </div>
              <div class="span-12-5">
                <div class="grid-12-sm">
                  <div class="span-6">
                    <div class="form-box">
                      <label>{{ 'Name_En' | translateWF: 'Name (EN)' }} *</label>
                      <input pInputText [formControl]="codeForm.controls.nameEn" class="w-full" placeholder="ISR services — resident" />
                    </div>
                  </div>
                  <div class="span-6">
                    <div class="form-box">
                      <label>{{ 'Name_Es' | translateWF: 'Name (ES)' }}</label>
                      <input pInputText [formControl]="codeForm.controls.nameEs" class="w-full" placeholder="ISR servicios — residente" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="span-6-2">
                <div class="form-box">
                  <label>{{ 'Rate' | translateWF: 'Rate (%)' }} *</label>
                  <p-inputNumber [formControl]="codeForm.controls.rate" styleClass="w-full" [minFractionDigits]="2" [maxFractionDigits]="4" [min]="0" [max]="100" suffix=" %" />
                </div>
              </div>
              <div class="span-6-2">
                <div class="form-box">
                  <label>{{ 'Residency' | translateWF: 'Residency' }}</label>
                  <p-select [formControl]="codeForm.controls.residency" [options]="residencyOptions" optionLabel="label" optionValue="value" styleClass="w-full" />
                </div>
              </div>
              <div class="span-6-3">
                <div class="form-box">
                  <label>{{ 'Effective_From' | translateWF: 'Effective from' }} *</label>
                  <p-datepicker [formControl]="codeForm.controls.effectiveFrom" styleClass="w-full" [showIcon]="true" />
                </div>
              </div>
              <div class="span-6-3">
                <div class="form-box">
                  <label>{{ 'Effective_To' | translateWF: 'Effective to (optional)' }}</label>
                  <p-datepicker [formControl]="codeForm.controls.effectiveTo" styleClass="w-full" [showIcon]="true" />
                </div>
              </div>
              <div class="span-12-6">
                <div class="form-box">
                  <label>{{ 'Posting_Account' | translateWF: 'Retenciones account' }}</label>
                  <app-financial-account-select
                    [referenceControl]="codeForm.controls.postingAccountReference"
                    [numberControl]="codeForm.controls.postingAccountNumber"
                    [nameControl]="codeForm.controls.postingAccountName"
                    [postingOnly]="true"
                  />
                </div>
              </div>
              <div class="span-12-3">
                <div class="form-box">
                  <label>{{ 'Description_En' | translateWF: 'Description (EN)' }}</label>
                  <input pInputText [formControl]="codeForm.controls.descriptionEn" class="w-full" />
                </div>
              </div>
              <div class="span-12-3">
                <div class="form-box">
                  <label>{{ 'Description_Es' | translateWF: 'Description (ES)' }}</label>
                  <input pInputText [formControl]="codeForm.controls.descriptionEs" class="w-full" />
                </div>
              </div>
              <div class="span-6-3 flex items-end">
                <div class="form-box">
                  <label class="row-sm-start-center">
                    <p-checkbox [formControl]="codeForm.controls.isActive" [binary]="true" />
                    {{ 'Active' | translateWF: 'Active' }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        }

        <p-table *ngIf="codes().length > 0" [value]="paginatedCodes()">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'Code' | translateWF: 'Code' }}</th>
              <th>{{ 'Name' | translateWF: 'Name' }}</th>
              <th class="text-right">{{ 'Rate' | translateWF: 'Rate' }}</th>
              <th>{{ 'Residency' | translateWF: 'Residency' }}</th>
              <th>{{ 'Effective_From' | translateWF: 'From' }}</th>
              <th>{{ 'Effective_To' | translateWF: 'To' }}</th>
              <th>{{ 'Posting_Account' | translateWF: 'Account' }}</th>
              <th>{{ 'Active' | translateWF: 'Active' }}</th>
              @if (!isReadOnly) {
                <th>{{ 'Actions' | translateWF: 'Actions' }}</th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-code>
            <tr>
              <td class="font-mono">{{ code.code }}</td>
              <td>{{ code.name | localized }}</td>
              <td class="text-right">{{ code.rate | number: '1.2-4' }}%</td>
              <td>{{ residencyLabel(code.residency) }}</td>
              <td>{{ code.effectiveFrom | date: 'dd/MM/yyyy' : 'UTC' }}</td>
              <td>{{ code.effectiveTo ? (code.effectiveTo | date: 'dd/MM/yyyy' : 'UTC') : '—' }}</td>
              <td class="font-mono">{{ code.postingAccount?.number || '—' }}</td>
              <td>
                <p-tag [value]="code.isActive ? 'Yes' : 'No'" [severity]="code.isActive ? 'success' : 'danger'" />
              </td>
              @if (!isReadOnly) {
                <td>
                  <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="info" (click)="editCode(code)" [pTooltip]="'Edit' | translateWF: 'Edit'" />
                </td>
              }
            </tr>
          </ng-template>
        </p-table>

        @if (codes().length > 0) {
          <p-paginator
            [rows]="codesPageSize()"
            [totalRecords]="codes().length"
            [first]="(codesCurrentPage() - 1) * codesPageSize()"
            (onPageChange)="onCodesPageChange($event)"
            [rowsPerPageOptions]="[10, 20, 50]"
          />
        }

        @if (codes().length === 0) {
          <div class="text-center py-6 text-gray-500">
            <p>{{ 'No_Codes_Found' | translateWF: 'No rate codes for this type yet.' }}</p>
          </div>
        }
      </div>
    }
  </div>
</main>
